import React from "react";
//import ReactDOM from 'react-dom';
//import axios from 'axios';
import Breadcrumb from '../Components/Breadcrumb';
import Contactus1 from "../Components/Contactus1";
import  './Contactus.css';
class Contactus extends React.Component {
    render() {
         return <div>
             <Breadcrumb head="Contact us"/>
<div className="contact-area mtb-50px">
                <div className="container">
                    <div className="contact-map mb-10">
                        <div className="mapouter">
                            <div className="gmap_canvas">
                                {/* <iframe id="gmap_canvas" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3946.091814438301!2d76.9472288145265!3d8.490453649529204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9843e7944fa0bf8b!2sPretty%20Pets%20Centre!5e0!3m2!1sen!2sin!4v1630037458650!5m2!1sen!2sin" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                                <a href="https://sites.google.com/view/maps-api-v2/mapv2"></a> */}
                            </div>
                        </div>
                    </div>
                    <div className="custom-row-2">
                        <div className="col-lg-4 col-md-5 mb-lm-30px">
                            <div className="contact-info-wrap my-contact-us">
                                <Contactus1 />
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-7">
                        
                        <div className="contact-form">
                            <div className="contact-title mb-30">
                                <h2>Enquire Now</h2>
                            </div>
                            <form className="contact-form-style" id="contact-form" action="#" method="post">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <input name="name" placeholder="Name*" type="text" />
                                    </div>
                                    <div className="col-lg-6">
                                        <input name="email" placeholder="Email*" type="email" />
                                    </div>
                                    <div className="col-lg-12">
                                        <input name="subject" placeholder="Subject*" type="text" />
                                    </div>
                                    <div className="col-lg-12">
                                        <textarea name="message" placeholder="Your Message*"></textarea>
                                        <button className="submit" type="submit">SEND</button>
                                    </div>
                                </div>
                            </form>
                            <p className="form-messege"></p>
                        </div>
                        </div>
                    </div>
                </div>
            </div>




</div>

}
}
export default Contactus;